<template >
    <v-container class="align">
        <!-- <v-flex>
        <img src="./pwa/images/time-left.svg"/>
    </v-flex>
    <h2>Session Timeout</h2>
    <p><a>Click here</a> to Login again.</p> -->
<v-card class="cards procDiv container" ref="modal" id="SessionTimeoutModal" data-keyboard="false" data-backdrop="static" style="max-width: 50%;">


<!-- Change password pop up  -->
<!-- <div class="modal" style="overflow-y: auto; border-radius: 15px; padding: 5px; width: 40%;height: max-content; border-radius: 15px;padding: 5px;" > -->
  
    <div style=" flex-direction: column">
     <v-flex style="text-align: center;">
        <img :src="imgSrc"/>
    </v-flex>
    <v-flex>
    <h2  style="text-align: center;">Session Timeout</h2>
    <h3 style="text-align: center;"><a @click="redirectToLoginPage()">Click here</a> to Login again.</h3>
    </v-flex>
    </div>
    
<!-- </div> -->

</v-card>
    </v-container>
</template>

<script type="text/javascript">
import imgSrc  from '@/assets/images/time-left.svg';
import router from '@/router';
export default {
      name: 'SessionTimeout',
       data: function () {
           return {
            imgSrc: imgSrc
           };
        },
        mounted: function(){
            this.$sunidhi.logoutBtnDisp = 'true';
        },

        methods : {
            async redirectToLoginPage(){
                // var self = this;
                this.$sunidhi.logoutBtnDisp = 'false';
                router.push({ name: 'LoginPage' });
                // deleteDBData();
                // window.location.reload(true);
            }
        }
    }
</script>

